import React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';
import { getEnvVar } from 'utils/env';

const Helmet = () => {
  return <ReactHelmet title={getEnvVar('TITLE')}></ReactHelmet>;
};

export default Helmet;
